.revenue-util-charts{height:400px;width:100%}
/*# sourceMappingURL=revenue-chart-helper-7VFMMF44.css.map */
